(function () {
  var box = document.querySelector('[data-legends-rx]');
  if (!box) return;
  var toggle = box.querySelector('[data-legends-rx-toggle]');
  var opts = box.querySelector('[data-legends-rx-opts]');
  var choices = box.querySelectorAll('[data-legends-rx-choice]');
  var stdValue = box.getAttribute('data-std-value') || '';
  if (!toggle) return;

  // Select a variant by driving Mila's (hidden) variant-picker radio, so its
  // native price / currency / id update path runs. Re-queried each call because
  // Mila re-renders the picker on variant change.
  function selectVariantByValue(value) {
    if (!value) return;
    var radios = document.querySelectorAll('[id$="-variant-picker"] input.js-option');
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].value === value) {
        if (!radios[i].checked) radios[i].click();
        return;
      }
    }
  }

  function selectedChoice() {
    for (var i = 0; i < choices.length; i++) {
      if (choices[i].checked) return choices[i];
    }
    return choices[0];
  }

  function apply() {
    var on = toggle.checked;
    if (opts) opts.hidden = !on;
    box.classList.toggle('is-on', on);
    if (on) {
      var c = selectedChoice();
      if (c) selectVariantByValue(c.value);
    } else {
      selectVariantByValue(stdValue);
    }
  }

  toggle.addEventListener('change', apply);
  for (var i = 0; i < choices.length; i++) {
    choices[i].addEventListener('change', function () {
      if (toggle.checked) {
        var c = selectedChoice();
        if (c) selectVariantByValue(c.value);
      }
    });
  }
})();
